import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import * as Yup from "yup";

import { BPIRevenueMoreThan3CroresForm } from "..";
import { IBusinessIncomes } from "../../../../config/interfaces";
import {
  BusinessIncomeFormInitValues,
  BusinessIncomeFormInitValuesFormSchema
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IBusinessIncomes | null;
  handleCloseBtnPress: (IBusinessIncomes: IBusinessIncomes | null) => void;
};

const BPIRevenueMoreThan3CroresDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IBusinessIncomes>(
    BusinessIncomeFormInitValues
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(BusinessIncomeFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          validationSchema={Yup.object().shape({ ...BusinessIncomeFormInitValuesFormSchema })}
          onSubmit={(values) => {
            handleCloseBtnPress(values);
          }}
        >
          {({ handleSubmit, validateForm, submitCount, isValid, errors }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Business Income Details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <BPIRevenueMoreThan3CroresForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={async (event) => {
                      event.preventDefault();
                      await validateForm();
                      handleSubmit();
                    }}
                  >
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default BPIRevenueMoreThan3CroresDetailsForm;
